import { format } from '@/libs/util.number.js'

export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_pendingGoodsInspectionNo') || '巡检单号',
    field: 'pendingGoodsInspectionNo',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_status') || '巡检状态',
    field: 'status',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_checkStatus') || '巡检结果',
    field: 'checkStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'checkStatus' },
  },
  {
    title: that.$l('table_label_reportDate') || '巡检日期',
    field: 'reportDate',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_workShopName') || '巡检车间',
    field: 'workShopName',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_processName') || '巡检工序',
    field: 'processName',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_reportPerson') || '巡检人员',
    field: 'reportPerson',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_masterNcNo') || '成品编码',
    field: 'masterNcNo',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_ncNo') || '子件编码',
    field: 'ncNo',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_goodsName') || '产品名称',
    field: 'goodsName',
    minWidth: 260,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_goodsSpec') || '产品尺寸',
    field: 'goodsSpec',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_goodsColor') || '产品颜色',
    field: 'goodsColor',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_factoryOrderNo') || '工厂订单编号',
    field: 'factoryOrderNo',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custOrderNo') || '客户订单编号',
    field: 'custOrderNo',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_authorBy') || '业务人员',
    field: 'authorByName',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_checkedQty') || '巡检数量',
    field: 'checkedQty',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => format(cellValue),
  },
  {
    title: that.$l('table_label_notPassQty') || '不良数量',
    field: 'notPassQty',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => format(cellValue),
  },
  {
    title: that.$l('table_label_passQty') || '良品数量',
    field: 'passQty',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => format(cellValue),
  },
  {
    title: that.$l('table_label_recheckBy') || '复检人',
    field: 'recheckBy',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayRecheck' },
  },
  {
    title: that.$l('table_label_createBy') || '创建人',
    field: 'createBy',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_label_modifyBy') || '修改人',
    field: 'modifyBy',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
]
